/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:pensieve
 */

import * as Types from '../../types/pensieve';

import { api } from 'app/apis/pensieve-gql-api';
export type MentorDash_LeaveQueueMutationVariables = Types.Exact<{ [key: string]: never }>;

export type MentorDash_LeaveQueueMutation = {
  __typename?: 'Mutation';
  queue?: {
    __typename?: 'queueMutationType';
    dequeue?: {
      __typename?: 'QueueReviewer';
      status?: Types.ReviewerStatus | null;
      expiresAt?: any | null;
      options: Array<{
        __typename?: 'QueueOpportunityOption';
        enabled: boolean;
        opportunity: { __typename?: 'QueueOpportunity'; project: { __typename?: 'QueueProject'; projectID: string } };
      }>;
    } | null;
  } | null;
};

export const MentorDash_LeaveQueueDocument = `
    mutation MentorDash_LeaveQueue {
  queue {
    dequeue {
      status
      expiresAt
      options {
        enabled
        opportunity {
          project {
            projectID
          }
        }
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_LeaveQueue: build.mutation<MentorDash_LeaveQueueMutation, MentorDash_LeaveQueueMutationVariables | void>(
      {
        query: (variables) => ({ document: MentorDash_LeaveQueueDocument, variables }),
      }
    ),
  }),
});

export { injectedRtkApi as api };
